/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Row,
  Col,
  Divider,
} from 'antd';
import {
  PageSection,
  messageError,
  ComponentLoader,
  messageSuccess,
} from '@deltaohm/ant-components';

import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';

import { extractGraphQLErrors } from '../../utils/graphql';

import { ErrorList } from '../../generics';

import { H2090ChangeUserForm, H2090ChangeOwnersForm } from '../components';
import { DEVICE_CHANGE_USER_MUTATION, DEVICE_CHANGE_OWNERS_MUTATION } from '../../devices/queries';

const H2090UserTab = (props) => {
  const {
    h2090,
  } = props;

  const { t } = useTranslation();

  const [
    deviceChangeUserAction,
    {
      loading: loadingChangeUser,
      error: errorChangeUser,
    },
  ] = useMutation(DEVICE_CHANGE_USER_MUTATION);

  const [
    deviceChangeOwnersAction,
    {
      loading: loadingChangeOwners,
      error: errorChangeOwners,
    },
  ] = useMutation(DEVICE_CHANGE_OWNERS_MUTATION);

  React.useEffect(() => {
    if (errorChangeUser || errorChangeOwners) {
      const errors = extractGraphQLErrors(errorChangeUser || errorChangeOwners, t);
      messageError({
        content: <ErrorList errors={errors} />,
      });
    }
  }, [errorChangeUser, errorChangeOwners, t]);

  const handleChangeUserFormSubmit = async (data) => {
    try {
      await deviceChangeUserAction({
        variables: {
          input: {
            id: h2090.id,
            email: data.email,
          },
        },
      });
      messageSuccess(t('common.successMessage'));
    }
    // eslint-disable-next-line no-empty
    catch (e) { }
  };

  const handleChangeOwnersFormSubmit = async (data) => {
    try {
      await deviceChangeOwnersAction({
        variables: {
          input: {
            id: h2090.id,
            emails: data.emails,
          },
        },
      });
      messageSuccess(t('common.successMessage'));
    }
    // eslint-disable-next-line no-empty
    catch (e) { }
  };

  return (
    <PageSection
      title={t('comboStations.userTab.title')}
    >
      <Row gutter={24}>
        <Col xs={24} md={12}>
          <Divider>
            {t('comboStations.userTab.userTitle')}
          </Divider>
          <ComponentLoader
            message={t('common.loading')}
            loading={loadingChangeUser}
          >
            <H2090ChangeUserForm
              h2090={h2090}
              onFormSubmit={handleChangeUserFormSubmit}
              canEdit={h2090.iAmOwner}
            />
          </ComponentLoader>
        </Col>

        <Col xs={24} md={12}>
          <Divider>
            {t('comboStations.userTab.ownersTitle')}
          </Divider>
          <ComponentLoader
            message={t('common.loading')}
            loading={loadingChangeOwners}
          >
            <H2090ChangeOwnersForm
              h2090={h2090}
              onFormSubmit={handleChangeOwnersFormSubmit}
              canEdit={h2090.iAmOwner}
            />
          </ComponentLoader>
        </Col>
      </Row>
    </PageSection>
  );
};

const propTypes = {
  h2090: PropTypes.object.isRequired,
};

H2090UserTab.propTypes = propTypes;

export default H2090UserTab;
